export const CLOUDFRONT_ID_REQUIRED = new Error(
  'ImageVariantPipe requires TISA_CLOUDFRONT_ID InjectionToken to be provided.',
);
